import React from 'react'
export const SquareSticksImg = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65" fill="none">
  <path d="M1.65063 1.50024H52.7095H63.6506V27.1256V63.5002H32.6506H1.65063V11.1458V1.50024Z" fill="white"/>
  <path d="M63.6506 1.50024H52.7095M63.6506 1.50024V27.1256M63.6506 1.50024L1.65063 63.5002M63.6506 63.5002V27.1256M63.6506 63.5002L1.65063 11.1458M63.6506 63.5002H32.6506M1.65063 63.5002L52.7095 1.50024M1.65063 63.5002V11.1458M1.65063 63.5002H32.6506M52.7095 1.50024H1.65063V11.1458M63.6506 27.1256L1.65063 11.1458M1.65063 11.1458L32.6506 63.5002" stroke="black" strokeWidth="2" strokeLinejoin="round"/>
</svg>
  )
}
